// 导入组件
import baseDialog from './src/base-dialog.vue'

// 为组件提供 install 安装方法，供按需引入
baseDialog.install = function (Vue) {
  Vue.component(baseDialog.name, baseDialog)
}

// 默认导出组件
export default baseDialog
